import { RefundDto } from '../dtos/refund.dto';
import { OrderBundleUnit } from '../models/order-bundle';
import { Refund } from '../models/refund';
import { dateMapper } from './date.mapper';
import { packageMapper } from './package.mapper';
import { productMapper } from './product.mapper';

export class RefundMultipleRegistrationsOptions {
  constructor(data) {
    this.orderId = data.orderId ?? data.id;
    this.amount = data.amount;
    this.isCheck = data.isCheck ?? false;
    this.checkNumber = data.checkNumber ?? null;

    /** @type {OrderBundleUnit[]} */
    this.units = data.units;
  }
}

/**
 * Map refund to dto.
 * TODO (Tien Luu) Create a mapper if use one more field from refunds
 * @param {RefundDto} refundDto Refund DTO.
 * @returns {Refund}
 */
function fromDto(refundDto) {
  return new Refund({
    id: refundDto.id,
    amount: refundDto.amount,
    approvedDate: dateMapper.fromDto(refundDto.approve_date),
    itemUnits: refundDto.item_units.map(item => ({
      id: item.id,
      assignee: item.assignee,
      isRefunded: item.is_refunded,
      package: packageMapper.basePackageFromDto(item.package),
      product: productMapper.fromDto(item.product),
    })),
    checkNumber: refundDto.check_number,
    isCheckType: Boolean(refundDto.is_check_type),
  });
}

/**
 * Map to refund multiple registrations.
 * @param {RefundMultipleRegistrationsOptions} options Options.
 * @returns {object}
 */
function toRefundMultipleRegistrationsDto(options) {
  return {
    amount: options.amount,
    item_unit_ids: options.units.map(unit => unit.id),
    is_check: options.isCheck,
    check_number: options.checkNumber,
  };
}

export const refundMapper = {
  toRefundMultipleRegistrationsDto,
  fromDto,
};
